<template>
  <div class="vsd420">
    <Head></Head>
    <div
      style="
        width: 99%;
        margin: 0 10px;
        height: calc(100vh - 6.225rem);
        position: absolute;
      "
      class="flex_1"
    >
      <img
        v-if="
          equip_data.product_type == '2' &&
          router_equip_data.children.length > 0
        "
        @click="downEquipData"
        style="
          position: absolute;
          bottom: 20%;
          left: 72%;
          width: 43px;
          height: 46px;
          z-index: 2000;
        "
        src="./down.svg"
        alt="#"
      />
      <img
        v-if="
          equip_data.product_type == '1' &&
          router_equip_data.children.length > 0 &&
          planIndex != 0
        "
        @click="downEquipData('pre')"
        style="
          position: absolute;
          bottom: 50%;
          left: 410px;
          width: 46px;
          height: 43px;
          z-index: 2000;
        "
        src="./model_left.svg"
        alt="#"
      />
      <img
        v-if="
          equip_data.product_type == '1' &&
          router_equip_data.children.length > 0 &&
          router_equip_data.children &&
          planIndex != router_equip_data.children.length - 1
        "
        @click="downEquipData('next')"
        style="
          position: absolute;
          bottom: 50%;
          right: 410px;
          width: 46px;
          height: 43px;
          z-index: 2000;
        "
        src="./model_right.svg"
        alt="#"
      />
      <DashboardLeft
        :equip_data="equip_data"
        :equip_data_info_list="equip_data_info_list"
        :router_equip_data="router_equip_data"

      ></DashboardLeft>
      <!-- 设备正常运行 -->
      <PanelData
        v-if="equip_data.is_iot_ready"
        :isPanelData="isPanelData"
        :currentState="equip_data.product_type == 2?groupCurrentState:currentState"
        :equip_data="equip_data"
      ></PanelData>
      <!-- 设备实时测点框 -->
      <Model
        ref="modelRef"
        v-if="equip_data.id"
        :equip_data="equip_data"
        :equip_data_info="equip_data_info"
        :chartlist="chartlist"
        :show-view="showView"
        :markeData="markeData"
        :currentState="currentState"
        :router_equip_data="router_equip_data"
        @getInstancesDetail="getInstancesDetail"
      ></Model>
      <component
        v-if="refresh"
        :is="iscom"
        :key="iscom"
        :equip_data="equip_data"
        :equip_data_info_list="equip_data_info_list"
        :chartlist="chartlist"
        :chartlists="chartlists"
        :isShowEcharts="isShowEcharts"
        @topIndexEvent="topIndexEvent"
      ></component>

      <Control
        :router_equip_data="router_equip_data"
        :isShowEcharts="isShowEcharts"
        :propName="chooseControls"
        :equip_data="equip_data"
        :topIndex="topIndex"
      ></Control>
    </div>
  </div>
</template>
<script>
// let list = [
//   "http://52.83.66.102:5011/public/2BE1.glb"
//   "http://52.83.66.102:5011/public/VSD420/干泵-振动设备.glb",
//   "http://52.83.66.102:5011/public/VSD420/干泵.glb",
//   "http://52.83.66.102:5011/public/VSD420/干泵-罗茨泵.glb",
//   "http://52.83.66.102:5011/public/VSD420/干泵-罗茨泵电机.glb",
//   "http://52.83.66.102:5011/public/VSD420/干泵-罗杆泵.glb",
//   "http://52.83.66.102:5011/public/VSD420/干泵-罗杆泵电机.glb",
//   "http://52.83.66.102:5011/public/VSD420/overall/罗茨泵点.glb",
//   "http://52.83.66.102:5011/public/VSD420/overall/罗茨泵电机点.glb",
//   "http://52.83.66.102:5011/public/VSD420/overall/螺杆泵点.glb",
//   "http://52.83.66.102:5011/public/VSD420/overall/螺杆泵电机点.glb",
//   "http://52.83.66.102:5011/public/VSD420/overall/罗茨泵上线.glb",
//   "http://52.83.66.102:5011/public/VSD420/overall/罗茨泵电机上线.glb",
//   "http://52.83.66.102:5011/public/VSD420/overall/螺杆泵上线.glb",
//   "http://52.83.66.102:5011/public/VSD420/overall/螺杆泵电机上线.glb"
// ];
// import { VSD420_OverAll } from "./data.js";
// import _ from "lodash";

import DashboardLeft from "@/components/devices/VSD420-OverAll/dashboard_left/DashboardLeft.vue";
import Control from "@/components/devices/Control";
import Model from "@/components/devices/VSD420-OverAll/Model3D.vue";
import PanelData from "@/components/devices/VSD420-OverAll/PanelData";
import DashboardRight from "@/components/devices/VSD420-OverAll/dashboard_right/DashboardRight";
import DashboardRightGroup from "@/components/devices/VSD420-OverAll/dashboard_right/DashboardRightGroup";

// 实例详情
import { getInstancesDetailId } from "@/service/index";
// import { reactive } from "vue";
// import { useRoute } from "vue-router"
import i18n from "@/i18n";
import appConfig from "../../../../app.config.json";
import { SOCKET_SVC_HOST,IS_DEMO_CUSTOMER_IDS,IS_DEMO_PAPER_MAKING_EP1000_ID } from "@/config/common.js";
import _ from "lodash";
import { valueFormatter1 } from "@/utils/common.js";
export default {
  page: {
    title: i18n.global.t("digital_twin"),
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  // setup() {
  //   const route = useRoute()
  //   const equip_data = reactive({});

  //   const data = localStorage.getItem('equip_id')
  //   getInstancesDetailId({id:route.query.equip_id||data}).then((res) => {
  //     if (res && res.payload) {
  //       Object.assign(equip_data, res.payload)
  //       console.log(Object.assign(equip_data, res.payload),"Object.assign(equip_data, res.payload)");
  //     }
  //   });
  //   return {
  //     equip_data
  //   };
  // },
  name: "vsd420-O",
  components: {
    DashboardLeft,
    Control,
    Model,
    PanelData,
    DashboardRight: DashboardRight,
    DashboardRightGroup: DashboardRightGroup,
  },
  data() {
    return {
      equip_data: {},
      equip_data_info: {},
      router_equip_data: {},
      chartlist: [],
      topIndex: [], //置顶测点状态
      currentId: null,
      isPanelData: true /* 设备正常运行状态 */,
      isShowEcharts: false /* 是否有IOT数据推送 */,
      title: i18n.global.t("digital_twin"),
      chooseControls: 1,
      onlineShop: false,
      showView: true,
      modelList: [],
      markeData: [],
      timer: null,
      timer1: null,
      timer2: null,
      currentState: "stop",
      torque: "24",
      equip_data_info_list: [],
      chartlists: [],
      planIndex: 0,
      refresh: true,
      mockSourceIds: [],
    };
  },
  computed: {    
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },
    //运行总时长
    operationHours() {
      const targetDate = new Date('2024-10-01T00:00:00'); // 目标日期
      const now = new Date(); // 当前时间
      const diff = now - targetDate; // 时间差（毫秒）
      let hours = Math.floor(diff / 3600000); // 转换成小时并向下取整

      if (hours <= 0) {
        return 0; // 如果小时数小于或等于0，返回0
      } else {
        return hours; // 否则返回计算出的小时数
      }
    },
    iscom() {
      return this.equip_data_info.product_type === "2"
        ? "DashboardRightGroup"
        : "DashboardRight";
    },
    // 泵头测点，假数据
    VSD420() {
      return {
        lcb: [
          {
            label: this.$t("Working Fluid Inlet Temperature"),
            value: "25",
            unit: "℃",
          },
          {
            label: this.$t("Working Fluid Outlet Temperature"),
            value: "15",
            unit: "℃",
          },
          {
            label: this.$t("Cooling Water Inlet Temperature"),
            value: "10",
            unit: "℃",
          },
          {
            label: this.$t("Cooling Water Outlet Temperature"),
            value: "13",
            unit: "℃",
          },
        ],
        lcbdj: [
          {
            label: this.$t("Inlet Prevalence Pressure"),
            value: "-96",
            unit: "kPaA",
          },
          {
            label: this.$t("Inlet Post-valve Pressure"),
            value: "-98",
            unit: "kPaA",
          },
          {
            label: this.$t("Drive Bearing Temperature"),
            value: "41",
            unit: "℃",
          },
          {
            label: this.$t("Drive Bearing Vibration"),
            value: "1.5",
            unit: "mm/s",
          },
          {
            label: this.$t("Non-driven Bearing Temperature"),
            value: "40.2",
            unit: "℃",
          },
          {
            label: this.$t("Non-driven Bearing Vibration"),
            value: "1.2",
            unit: "mm/s",
          },
        ],
        lgb: [
          {
            label: this.$t("Currentting"),
            value: "35",
            unit: "A",
          },
          {
            label: this.$t("Rotation Speed Realy"),
            value: "680",
            unit: "rpm",
          },
          {
            label: this.$t("Winding Temperature U"),
            value: "61",
            unit: "℃",
          },
          {
            label: this.$t("Winding Temperature V"),
            value: "62",
            unit: "℃",
          },
          {
            label: this.$t("Winding Temperature W"),
            value: "60",
            unit: "℃",
          },
          {
            label: this.$t("Drive Bearing Temperature"),
            value: "53",
            unit: "℃",
          },
          {
            label: this.$t("Non-driven Bearing Temperature"),
            value: "54.1",
            unit: "℃",
          },
        ],
        lgbs: [
          {
            label: this.$t("Cooling water flow"),
            value: "10",
            unit: "L/min",
          },
          {
            label: this.$t("Cooling water temperature"),
            value: "30",
            unit: "℃",
          },
          {
            label: this.$t("X-directional vibration"),
            value: "0.8",
            unit: "mm/s",
          },
          {
            label: this.$t("Y-directional vibration"),
            value: "0.8",
            unit: "mm/s",
          },
          {
            label: this.$t("Inlet pressure"),
            value: "9",
            unit: "mbarA",
          },
          {
            label: this.$t("Inlet temperature"),
            value: "70",
            unit: "℃",
          },
        ],
        lgbdjs: [
          {
            label: this.$t("Torque"),
            value: "24",
            unit: "N·m",
          },
          {
            label: this.$t("Current"),
            value: "22",
            unit: "A",
          },
          {
            label: this.$t("Rotation Speed"),
            value: "2950",
            unit: "rpm",
          },
          {
            label: this.$t("Power consumption"),
            value: "7.7",
            unit: "kW",
          },
          {
            label: this.$t("Bearing temperature"),
            value: "75",
            unit: "℃",
          },
          {
            label: this.$t("X-directional vibration"),
            value: "0.8",
            unit: "mm/s",
          },
          {
            label: this.$t("Y-directional vibration"),
            value: "0.8",
            unit: "mm/s",
          },
        ],
        lgbdfj: [
          {
            label: "出口压力",
            value: "990",
            unit: "mabrG",
          },
          {
            label: "入口风量",
            value: "719",
            unit: "Am³/h",
          },
          {
            label: "入口温度",
            value: "709",
            unit: "°C",
          },
          {
            label: "运行电流",
            value: "59.3",
            unit: "A",
          },
        ],
      };
    },
    //关于机组状态
    currentObj(){
      return this.$store.state.equipManagement.current_obj;
    },
    groupCurrentState(){ 
      let reslut  = "stop";
      let obj = { "stop":0,"normal":0 }
      for(let key in this.currentObj){
        for(let measu in this.currentObj[key]){
          if (this.currentObj[key][measu]>2) {
            obj["normal"] += 1
          }
        }
      }
      if (obj["normal"]) {
        reslut = "normal"
      }
      return reslut;
    }, 
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.markeData = this.VSD420;
      },
      deep: true,
    },
    torque: {
      handler(val) {
        /* todo根据纽米值判断status值 29.7 34.5 */
        this.markeData["lgbdj"].forEach((obj) => {
          if (obj.label == this.$t("Torque")) {
            obj.value = val;
          }
        });
      },
      deep: true,
    },
    chartlists: {
      handler(val) {
        if (val) {
          this.currentState = "stop";
          val.map((item) => {
            item.list.forEach((obj) => {
              //判断当前机组已电流判断开关机还是功率
              if (this.isCurrentState(obj)) {
                if (obj.v > 2) {
                  this.currentState = "normal";
                }
              }
            });
          });
        }
      },
      deep: true,
    },
    chartlist: {
      handler(val) {
        if (val) {
          this.currentState = "stop";
          val.map((item) => {
            if (this.isCurrentState(item)) {
              if (item.v > 2) {
                this.currentState = "normal";
              } 
            }
          });
        }
      },
      deep: true,
    },
    /* 判断是否为"智能运维模式" ,获取得当前机组设备信息,决定是否展示页面 */
    equip_data_info:{
      handler(val){
        if (val.attributes &&val.attributes.attributes.length) {
          let info = val.attributes.attributes.find(item=>item.name === "智能运维模式"&&item.value === "是")
          if(info){
            this.$store.commit( "equipManagement/set_is_stmart_om_equipment", true); 
            //获取需要展示得数据
            this.$store.commit( "equipManagement/set_equip_data", _.cloneDeep(val));
          }else{
            this.$store.commit( "equipManagement/set_is_stmart_om_equipment", false); 
          }
        }
        
      },immediate:true
    },
    router_equip_data:{
      handler(val){
        this.$store.commit( "equipManagement/set_router_equip_data", val); 
      },immediate:true
    }
  },
  created() {},
  mounted() {
    this.getInstancesDetail();
    this.markeData = this.VSD420;

    this.initWebSocket();
  },

  methods: {
    buildMockSourceFromPayload(payload) {
      if (!payload || !payload.id) return null;
      const measurements =
        payload.attributes && Array.isArray(payload.attributes.measurements)
          ? payload.attributes.measurements
              // smartOM 需要完整测点，不能仅按 is_show 过滤
              .filter((item) => item && item.key)
              .map((item) => ({
                key: item.key,
                name: item.name,
                full_name: item.full_name,
                unit: item.unit,
                operationThresholdLow: item.operationThresholdLow,
                operationThresholdHigh: item.operationThresholdHigh,
                standardThresholdLow: item.standardThresholdLow,
                standardThresholdHigh: item.standardThresholdHigh,
              }))
          : [];
      return {
        shadowId: payload.id,
        equipName: payload.name || "",
        measurements,
      };
    },
    syncMockSources(payloads = []) {
      const sourceMap = {};
      payloads.forEach((payload) => {
        const source = this.buildMockSourceFromPayload(payload);
        if (!source) return;
        if (!sourceMap[source.shadowId]) {
          sourceMap[source.shadowId] = {
            shadowId: source.shadowId,
            equipName: source.equipName,
            measurements: [],
          };
        }
        const sourceTarget = sourceMap[source.shadowId];
        const keyMap = {};
        sourceTarget.measurements.forEach((item) => {
          if (item && item.key) keyMap[item.key] = true;
        });
        source.measurements.forEach((measurement) => {
          if (!measurement || !measurement.key || keyMap[measurement.key]) return;
          keyMap[measurement.key] = true;
          sourceTarget.measurements.push(measurement);
        });
      });
      const sources = Object.values(sourceMap);
      if (this.mockSourceIds.length) {
        this.$websocket.dispatch("WEBSOCKET_UNREGISTER_MOCK_SOURCE", this.mockSourceIds);
      }
      if (sources.length) {
        this.$websocket.dispatch("WEBSOCKET_REGISTER_MOCK_SOURCE", sources);
      }
      this.mockSourceIds = sources.map((item) => item.shadowId);
    },
    syncPageMockSources(rootPayload) {
      const payloads = [];
      if (rootPayload) payloads.push(rootPayload);
      // smartOM 依赖部分非 is_show 测点（如 2#MF），优先使用 root 原始 children 补齐注册源
      if (rootPayload && Array.isArray(rootPayload.children) && rootPayload.children.length) {
        payloads.push(...rootPayload.children);
      }
      if (this.equip_data_info_list && this.equip_data_info_list.length) {
        payloads.push(...this.equip_data_info_list);
      }
      this.syncMockSources(payloads);
    },
    //判断当前机组已电流判断开关机还是功率
    isCurrentState(item){
      if(this.equip_data.id == IS_DEMO_PAPER_MAKING_EP1000_ID){
        return item.name.includes("功率");
      }else{
        return item.name == "电流";
      }
    },
    async downEquipData(type) {
      this.$refs.modelRef.setStaticModelImg()
      this.currentState = "stop";
      if (type) {
        switch (type) {
          case "next":
            if (this.planIndex == this.router_equip_data.children.length - 1) {
              this.planIndex = this.router_equip_data.children.length - 1;
              return;
            } else {
              this.planIndex++;
            }
            break;
          case "pre":
            if (this.planIndex < 0) {
              this.planIndex = 0;
              return;
            } else {
              this.planIndex--;
            }
            break;
        }
      }

      let eqId = this.router_equip_data.children[this.planIndex].id;
      await getInstancesDetailId({ id: eqId }).then((res) => {
        if (res && res.payload) {
          this.chartlist = [];

          let reslut = res.payload;
          /* 判断当前客户设备是否为演示客户 */ 
          if(IS_DEMO_CUSTOMER_IDS.includes(reslut.customer_id) && reslut.product_type == 2 ){ //客户id 和机组
            this.$store.commit( "equipManagement/set_total_duration", this.operationHours); //存储总时长
            this.$store.commit( "equipManagement/set_is_demonstration_equipment", true);
            if (this.timer2) {
              clearInterval(this.timer2)
              this.timer2 = null
            }
            this.timer2 = setInterval(()=>{
              this.$store.commit( "equipManagement/set_total_duration", this.operationHours);
            },300000) //间隔5分钟查询一次
          }else{
            this.$store.commit( "equipManagement/set_is_demonstration_equipment", false); 
          }
          /* 测点列表,筛选出需要展示的测点数据 */
          let list = [];
          if (
            res.payload.attributes &&
            res.payload.attributes.measurements.length
          ) {
            list = res.payload.attributes.measurements.filter(
              (item) => item.is_show === undefined || item.is_show
            );
          }
          reslut.attributes.measurements = list;
          this.chartlist = list.map(m=>({
            ...m,
            equipment_id:res.payload.id,
            equipment_name:res.payload.name,
            root_sn:res.payload.root_sn,
          }));

          this.equip_data = Object.assign(this.equip_data, reslut);
          this.equip_data_info = _.cloneDeep(res.payload);
          /* 设备id用户推送数据设备id匹配 */
          this.currentId = reslut.id;
          this.refresh = false;
          this.$nextTick(() => {
            this.refresh = true;
          });
          this.syncPageMockSources(res.payload);
        }
      });
    },
    async routerChange() {
      let eqId = this.$route.query.sub_id;
      this.router_equip_data.children.forEach((item, index) => {
        if (item.id == eqId) {
          this.planIndex = index;
        }
      });
      await getInstancesDetailId({ id: eqId }).then((res) => {
        if (res && res.payload) {
          this.chartlist = [];

          let reslut = res.payload;
          /* 判断当前客户设备是否为演示客户 */ 
          if(IS_DEMO_CUSTOMER_IDS.includes(reslut.customer_id) && reslut.product_type == 2 ){ //客户id 和机组
            this.$store.commit( "equipManagement/set_total_duration", this.operationHours); //存储总时长
            this.$store.commit( "equipManagement/set_is_demonstration_equipment", true);
            if (this.timer2) {
              clearInterval(this.timer2)
              this.timer2 = null
            }
            this.timer2 = setInterval(()=>{
              this.$store.commit( "equipManagement/set_total_duration", this.operationHours);
            },300000) //间隔5分钟查询一次
          }else{
            this.$store.commit( "equipManagement/set_is_demonstration_equipment", false); 
          }
          /* 测点列表,筛选出需要展示的测点数据 */
          let list = [];
          if (
            res.payload.attributes &&
            res.payload.attributes.measurements.length
          ) {
            list = res.payload.attributes.measurements.filter(
              (item) => item.is_show === undefined || item.is_show
            );
          }
          reslut.attributes.measurements = list;
          this.chartlist = list.map(m=>({
            ...m,
            equipment_id:res.payload.id,
            equipment_name:res.payload.name,
            root_sn:res.payload.root_sn,
          }));

          this.equip_data = Object.assign(this.equip_data, reslut);
          this.equip_data_info = _.cloneDeep(res.payload);
          /* 设备id用户推送数据设备id匹配 */
          this.currentId = reslut.id;
          this.refresh = false;
          this.$nextTick(() => {
            this.refresh = true;
            this.$route.query.sub_id = null;
          });
          this.syncPageMockSources(res.payload);
        }
      });
    },
    valueFormatter1,
    /* 置顶测点状态 */
    topIndexEvent(topIndex) {
      this.topIndex = topIndex;
    },
    async getInstancesDetail() {
      this.currentState = "stop";
      this.chartlists = [];
      this.chartlist = [];
      const data = localStorage.getItem("equip_id");
      await getInstancesDetailId({
        id: this.$route.query.equip_id || data,
      }).then((res) => {
        if (res && res.payload) {
          let reslut = res.payload;
          
          localStorage.setItem("statistics_id", reslut.customer_id);//存储当前客户id
          /* 判断当前客户设备是否为演示客户 */ 
          if(IS_DEMO_CUSTOMER_IDS.includes(reslut.customer_id) && reslut.product_type == 2 ){ //客户id 和机组
            this.$store.commit( "equipManagement/set_total_duration", this.operationHours); //存储总时长
            this.$store.commit( "equipManagement/set_is_demonstration_equipment", true);
            if (this.timer2) {
              clearInterval(this.timer2)
              this.timer2 = null
            }
            this.timer2 = setInterval(()=>{
              this.$store.commit( "equipManagement/set_total_duration", this.operationHours);
            },300000) //间隔5分钟查询一次
          }else{
            this.$store.commit( "equipManagement/set_is_demonstration_equipment", false); 
          }
          /* 测点列表,筛选出需要展示的测点数据 */
          let list = [];
          if (
            res.payload.attributes &&
            res.payload.attributes.measurements.length
          ) {
            list = res.payload.attributes.measurements.filter(
              (item) => item.is_show === undefined || item.is_show
            );
          }
          reslut.attributes.measurements = list.map(m=>({
            ...m,
            equipment_id:res.payload.id,
            equipment_name:res.payload.name,
            root_sn:res.payload.root_sn,
          }));
          this.chartlist = list.map(m=>({
            ...m,
            equipment_id:res.payload.id,
            equipment_name:res.payload.name,
            root_sn:res.payload.root_sn,
          }));
          
          this.equip_data = Object.assign(this.equip_data, reslut);
          this.router_equip_data = _.cloneDeep(this.equip_data);
          this.equip_data_info = _.cloneDeep(res.payload);
          this.equip_data_info_list = []
          //造纸厂
          if(this.isPaperMaking){
            let list_m = []
            let obj = {}
            this.equip_data_info_list = _.cloneDeep(res.payload.children); 
            this.equip_data_info_list.forEach((item) => {
              if (item.attributes && item.attributes.measurements.length) {
                  //过滤出需要展示的测点数据，equipment_id_key:设备id+测点key 作为唯一标识
                  let reslut = [];
                  item.attributes.measurements.forEach((items) => {
                    items.equipment_id_key = item.id+"-"+ items.key
                    if(items.is_show === undefined || items.is_show){
                      reslut.push({
                        ...items, 
                      })
                    }
                  });
                  item.attributes.measurements = reslut;

                const data =   item.attributes.measurements.map(m=>({
                    ...m,
                    equipment_id:item.id,
                    equipment_name:item.name,
                    root_sn:item.root_sn,
                  }))
                this.chartlists.push({
                  iconType: true,
                  data: item,
                  list: data,
                  chartIndex: [],
                });
                
                list_m.push(data);
                
                /* 找出含有“电流”测点，用于判断机组开停机 */ 
                let info = item.attributes.measurements.find(item=>this.isCurrentState(item))
                if (!obj[item.id]) {
                  obj[item.id] = {}
                  if (info) obj[item.id][info.key] = '-'
                }
              }
            });
            this.chartlist = [...this.chartlist, ...list_m.flat()]
            
            this.$store.commit( "equipManagement/set_current_obj", obj);
          }else{
            if (
              res.payload.children.length > 0 &&
              res.payload.product_type == "2"
            ) {
              this.equip_data_info_list = _.cloneDeep(res.payload.children);
              let obj = {}
              this.equip_data_info_list.forEach((item) => {
                if (item.attributes && item.attributes.measurements.length) {
                  item.attributes.measurements = item.attributes.measurements.map(m=>({
                    ...m,
                    equipment_id_key:item.id+"-"+ m.key,
                  }))
                  item.attributes.measurements =
                    item.attributes.measurements.filter(
                      (items) => items.is_show === undefined || items.is_show
                    );
                  this.chartlists.push({
                    iconType: true,
                    data: item,
                    list: item.attributes.measurements,
                    chartIndex: [],
                  });
                  this.chartlist.push(item.attributes.measurements);
                  /* 找出含有“电流”测点，用于判断机组开停机 */ 
                  let info = item.attributes.measurements.find(item=>this.isCurrentState(item))
                  if (!obj[item.id]) {
                    obj[item.id] = {}
                    if (info) obj[item.id][info.key] = '-'
                  }

                }
              });
              
              /* 存储获取到的“电流”测点 */ 
              this.$store.commit( "equipManagement/set_current_obj", obj);

              // this.equip_data = this.equip_data_info_list[0];
              /* 设备id用户推送数据设备id匹配 */
              this.currentId = this.equip_data_info_list[0].id;
              this.chartlist =
                this.equip_data_info_list[0].attributes.measurements;
            }
          }
          
          if (this.$route.query.sub_id) {
            this.routerChange();
          }
          // this.equip_data_info_list.reverse() //反转
          // this.chartlists.reverse() //反转
          // this.chartlist.reverse() //反转
          // console.log(this.equip_data_info_list,"this.equip_data_info_list")
          // console.log(this.chartlist,"this.chartlist")
          // console.log(this.chartlists,"this.chartlists")
          this.refresh = false;
          this.$nextTick(() => {
            this.refresh = true;
          });
          this.syncPageMockSources(res.payload);
        }
      });
    },

    //** WebSocket 实时获取实例详情测点数据 */
    initWebSocket() {
      const interval = setInterval(() => {
        if (this.retryCount > 10) {
          clearInterval(interval);
          this.retryCount = 0;
          return;
        }
        const stompClient = this.$websocket.getters.stompClient();
        if (stompClient != null && stompClient.connected) {
          clearInterval(interval);
          stompClient.subscribe("/topic/stream", (msg) => {
            if (msg && msg.body) {
              let websocketdata = Array.isArray(JSON.parse(msg.body))
                ? JSON.parse(msg.body)
                : [JSON.parse(msg.body)];
              /* 避免其他页面触发 */
              if (this.$route.path == "/VSD420-OverAll") {
                /*  获取推送数据,处理 */
                this.getWebsocket(websocketdata);
              }
            }
          });
        } else {
          if (!localStorage.getItem("accessToken")) return;
          const _url =
            SOCKET_SVC_HOST +
            "/messaging/stomp?access_token=" +
            localStorage.getItem("accessToken");
          this.$websocket.dispatch("WEBSOCKET_INIT", _url);
        }
        this.retryCount++;
      }, 1000);
    },
    // 获取推送数据,处理
    getWebsocket(socdata) {
      let current_obj = _.cloneDeep(this.currentObj)
      if (socdata && socdata.length) {
        socdata.map((soc) => {
          /* 匹配推送的对应设备的id */
          if (soc.report.length) {
            /* 是否有IOT数据，是否展示升级  按钮 HEALTH 0, WARNING 1, ERROR 2 */
            this.isShowEcharts = true;
            if (
              soc.report.some((item) => item.stat == 1) ||
              soc.report.some((item) => item.stat == 2)
            ) {
              this.isPanelData = false; //存在异常,不展示该图标
            } else if (soc.report.every((item) => item.stat == 0)) {
              this.isPanelData = true; //未存在异常,展示该图标
            }
            for (let item of soc.report) {
              if (this.iscom === "DashboardRightGroup") {
                if (this.chartlists.length > 0) {
                  this.chartlists.map((charts) => {
                    let _index1 = -1
                    //造纸厂
                    if(this.isPaperMaking){
                      _index1 = charts.list.findIndex(
                        (i) => i.equipment_id === soc.shadowId &&i.key === item.id
                      );
                    }else{
                      _index1 = charts.list.findIndex(
                        (i) => i.key === item.id
                      );
                    }
                    if (_index1 > -1) {
                      charts.list[_index1] = {
                        ...charts.list[_index1],
                        v: valueFormatter1(item.v),
                        stat: item.stat,
                      };
                    }
                  });
                }
              } else {
                /* 复制对应测点值 */
                let _index = this.chartlist.findIndex((i) => i.key === item.id);
                if (_index > -1) {
                  this.chartlist[_index] = {
                    ...this.chartlist[_index],
                    v: valueFormatter1(item.v),
                    stat: item.stat,
                  };
                }
              }

              /* 设备的开停机状态 */ 
              if(current_obj[soc.shadowId]){
                for(let key in current_obj[soc.shadowId]){
                  if (key == item.id) {
                    current_obj[soc.shadowId][key] = item.v
                  }
                }
              }
            }
          }
        });
      }
      this.$store.commit( "equipManagement/set_current_obj", current_obj); 
    },
    // pandaun
    // changeData() {
    //   let copyData = _.cloneDeep(this.VSD420);
    //   Object.values(copyData).forEach(obj => {
    //     obj.forEach(data => {
    //       if (data.label != this.$t("Torque")) {
    //         if (data.label == this.$t("Power consumption")) {
    //           data.value = this.randoms(
    //             Number(data.value),
    //             Number(data.value) + 0.1
    //           );
    //         } else {
    //           data.value = this.randoms(
    //             Number(data.value),
    //             Number(data.value) + 1
    //           );
    //         }
    //       }
    //     });
    //   });
    //   return copyData;
    // },
    randoms(min, max) {
      return parseFloat(Math.random() * (max - min) + min).toFixed(1);
    },
  },
  beforeUnmount() {
    clearInterval(this.timer2)
    if (this.mockSourceIds.length) {
      this.$websocket.dispatch("WEBSOCKET_UNREGISTER_MOCK_SOURCE", this.mockSourceIds);
      this.mockSourceIds = [];
    }
  }
};
</script>

<style lang="scss">
@import url("../../../assets/scss/common.scss");

.vsd420 {
  width: 100%;
  height: 100vh;
  position: relative;
  font-size: 16px;
  background-image: radial-gradient(circle, #2f5278, #0f2239, #071729);
  color: #fff;
}
</style>
